import { combineReducers } from 'redux'

import { IWheelGameState } from '../types'
import communications from './communications'
import data from './data'

export const reducer = combineReducers<IWheelGameState>({
  communications,
  data,
})
